'use strict';

/**
 * trustHtml - filtre pour transformer du texte brut en HTML sécurisé
 * Ce filtre utilise $sce (Strict Contextual Escaping) pour garantir 
 * que le contenu HTML est sûr avant de l'afficher
 */
angular.module('observatoireApp')
.filter('trustHtml', ['$sce', function($sce) {
  return function(text) {
    return $sce.trustAsHtml(text);
  };
}]);
